import type { FlowBuilderTurnStatus } from '../../types/flowBuilder/flowBuilderApi';

/** Os mesmos estados que o core conta como turno vivo do agente (o `liveTurnId` da sessão). */
const LIVE_TURN_STATUSES: ReadonlySet<FlowBuilderTurnStatus> = new Set(['QUEUED', 'RUNNING']);

/** Turno na fila ou rodando: o worker ainda pode gravar o rascunho do agente. */
export function isLiveTurnStatus(status: FlowBuilderTurnStatus): boolean {
  return LIVE_TURN_STATUSES.has(status);
}
